export default __webpack_public_path__ + "static/media/tms.d129caa9.svg";